export default [
  {
    path: "/scientific-drugs-names",
    name: "scientific-drugs-names",
    component: () => import("@/views/pharmacy/ScientificDrugName.vue"),
  },
  {
    path: "/drugs",
    name: "drugs",
    component: () => import("@/views/pharmacy/Drug.vue"),
  },
  {
    path: "/add-patient-drug/:patient_card_id",
    name: "add-patient-drug",
    component: () => import("@/views/pharmacy/AddPatientDrug.vue"),
  },
  {
    path: "/patients-has-drugs",
    name: "patients-has-drugs",
    component: () => import("@/views/pharmacy/Patients.vue"),
  },
  {
    path: "/pharmacy-patient/:id",
    name: "pharmacy-patient",
    component: () => import("@/views/Reception/PatientCardPharmacy.vue"),
  },
  {
    path: "/pharmacy-warehouse",
    name: "pharmacy-warehouse",
    component: () => import("@/views/warehouse/Warehouse.vue"),
  },

  {
    path: "/pharmacy-category",
    name: "pharmacy-category",
    component: () => import("@/views/warehouse/Category.vue"),
  },
  {
    path: "/pharmacy-scientific-drugs-names",
    name: "pharmacy-scientific-drugs-names",
    component: () => import("@/views/pharmacy/ScientificDrugName.vue"),
  },
  {
    path: "/pharmacy-category/:id",
    name: "pharmacy-subcategory",
    component: () => import("@/views/warehouse/SubCategory.vue"),
  },

  {
    path: "/pharmacy-item/:id?",
    name: "pharmacy-item",
    component: () => import("@/views/warehouse/Item.vue"),
  },
  {
    path: "/pharmacy-stockin",
    name: "pharmacy-stockin",
    component: () => import("@/views/warehouse/Stockin.vue"),
  },
  {
    path: "/pharmacy-stockout/:id?",
    name: "pharmacy-stockout",
    component: () => import("@/views/warehouse/Stockout.vue"),
  },

  {
    path: "/pharmacy-add-stockin",
    name: "pharmacy-add-stockin",
    component: () => import("@/views/warehouse/AddStockin.vue"),
  },

  {
    path: "/pharmacy-dispense-drug/:patient_card_id/:quantity/:id",
    name: "pharmacy-dispense-drug",
    component: () => import("@/views/pharmacy/DispenseDrug.vue"),
  },
  {
    path: "/pharmacy-add-stockout",
    name: "pharmacy-add-stockout",
    component: () => import("@/views/warehouse/AddStockout.vue"),
  },

  {
    path: "/pharmacy-inventory-invoice",
    name: "pharmacy-inventory-invoice",
    component: () => import("@/views/warehouse/Invoice.vue"),
  },
  {
    path: "/pharmacy-balance",
    name: "pharmacy-balance",
    component: () => import("@/views/warehouse/Balance.vue"),
  },
  {
    path: "/SaleOfPoint",
    name: "sale-of-point",
    component: () => import("@/views/pharmacy/SaleOfPoint.vue"),
  },
  {
    path: "/DrugStore",
    name: "drug-store",
    component: () => import("@/views/pharmacy/DrugStore.vue"),
  },
];
